module.exports = __webpack_public_path__ + "1.5.0-unryo/img/online-analytic-5.2a6f2a13.svg";